(function () {
  var loaded = false;

  function loadPredictiveSearch() {
    if (loaded || !window.predictiveSearchScriptUrl) return;
    loaded = true;
    document.removeEventListener('focusin', onFocusIn);
    document.removeEventListener('click', onClick);

    var script = document.createElement('script');
    script.src = window.predictiveSearchScriptUrl;
    script.defer = true;
    document.head.appendChild(script);
  }

  function onFocusIn(event) {
    if (event.target && event.target.matches('input[type="search"], input[name="q"]')) {
      loadPredictiveSearch();
    }
  }

  function onClick(event) {
    if (event.target && event.target.closest('details-modal, .search-modal, predictive-search')) {
      loadPredictiveSearch();
    }
  }

  function bind() {
    document.addEventListener('focusin', onFocusIn);
    document.addEventListener('click', onClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
